import { useRouteParams } from "src/hooks/useRouteParams";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { DevelopmentParams } from "src/routes/routesDef";

export function ProductOfferingConfigsPage() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  return <ProductOfferingConfigsPageView marketsOrIds={{ developmentId }} />;
}
